import { PurchasedItemType } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { BaseMenuItem } from "@/types";

export const filterItems: BaseMenuItem[] = [
  {
    text: $t("All content"),
    name: "all",
    value: undefined,
  },
  {
    text: $t("Media posts"),
    name: "media",
    value: [PurchasedItemType.MEDIA_POST],
  },
  ...(config.featureTextPosts
    ? [
        {
          text: $t("Text posts"),
          name: "text",
          value: [PurchasedItemType.RICH_TEXT_POST],
        },
      ]
    : []),
  {
    text: $t("Messages"),
    name: "message",
    value: [PurchasedItemType.MESSAGE_ATTACHMENT],
  },
];
